import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="lightest" className="titleBlock-align-left technical-case-title" mdxType="TitleBlock" />
    <h2 {...{
      "id": "technical-use-cases"
    }}>{`Technical use cases`}</h2>
    <TextBlock slots="image, heading, text" width="50%" theme="lightest" className="align-left bg-grey iocn-size   technical-case-one tech-usecse tech-usecse-align-left" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/76d496dd94ebea75829314eb33dfaf24/improveAccessibility.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "improve-accessibility-of-pdf-backlogs"
    }}>{`Improve accessibility of PDF backlogs`}</h3>
    <p>{`Use the API to improve the accessibility of existing backlogs of native or scanned PDFs at scale in minutes.`}</p>
    <TextBlock slots="image, heading, text" width="50%" theme="lightest" className="align-left bg-grey iocn-size technical-case-two tech-usecse tech-usecse-align-left" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/afb4d79e048ba5601e43ade2d57350de/accessibilityWorkFlows.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "accelerate-accessibility-workflows"
    }}>{`Accelerate accessibility workflows`}</h3>
    <p>{`Add the API to document automation workflows so all new PDFs or third-party content are automatically tagged from the get-go.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      